import Router from "vue-router";
import Vue from "vue";
import report from "@/views/channelClient/report.vue";
import offer from "@/views/channelClient/offer.vue";
import mmpOffer from "@/views/channelClient/mmpOffer.vue";
import billing from "@/views/channelClient/billing.vue";
import offerPayment from "@/views/channelClient/offerPayment.vue";
import login from "@/views/channelClient/login.vue";
import apiDocument from "@/views/channelClient/apiDocument.vue";
import implog from "@/views/channelClient/implog.vue";

Vue.use(Router);
export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			redirect: "/report",
		},
		{
			path: "/report",
			name: "report",
			component: report,
		},
		{
			path: "/offer",
			name: "offer",
			component: offer,
		},
		{
			path: "/mmpOffer",
			name: "mmpOffer",
			component: mmpOffer,
		},
		{
			path: "/billing",
			name: "billing",
			component: billing,
		},
		{
			path: "/offerPayment",
			name: "offerPayment",
			component: offerPayment,
		},
		{
			path: "/apiDocument",
			name: "apiDocument",
			component: apiDocument,
		},
		{
			path: "/implog",
			name: "implog",
			component: implog,
		},
		{
			path: "/login",
			name: "login",
			component: login,
		},
	],
});
